import { useState } from "react";
import { Send, Users } from "lucide-react";
import { SORV_PROJECTS } from "../config/sorv-projects";

interface CommandBarProps {
  onSendTask: (projectId: string, agentId: string | null, instruction: string) => void;
  onSync?: (projectId: string) => void;
}

export function CommandBar({ onSendTask, onSync }: CommandBarProps) {
  const [projectId, setProjectId] = useState(SORV_PROJECTS[0]?.id || "");
  const [agentId, setAgentId] = useState<string>("");
  const [instruction, setInstruction] = useState("");

  const selectedProject = SORV_PROJECTS.find((p) => p.id === projectId) ?? SORV_PROJECTS[0];
  const agents = selectedProject?.agents ?? [];

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!instruction.trim() || !projectId) return;
    onSendTask(projectId, agentId || null, instruction.trim());
    setInstruction("");
  }

  return (
    <div className="bg-surface-2 border-t border-border px-4 py-3">
      <form onSubmit={handleSubmit} className="flex items-center gap-3">
        {/* Project selector */}
        <select
          value={projectId}
          onChange={(e) => {
            setProjectId(e.target.value);
            setAgentId("");
          }}
          className="input text-xs w-40 flex-shrink-0"
        >
          {SORV_PROJECTS.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name.split("/")[0]?.trim() ?? p.name}
            </option>
          ))}
        </select>

        {/* Agent selector */}
        <select
          value={agentId}
          onChange={(e) => setAgentId(e.target.value)}
          className="input text-xs w-44 flex-shrink-0"
        >
          <option value="">Todos los agentes</option>
          {agents.map((a) => (
            <option key={a.id} value={a.id}>
              {a.name}
            </option>
          ))}
        </select>

        {/* Instruction input */}
        <input
          type="text"
          value={instruction}
          onChange={(e) => setInstruction(e.target.value)}
          placeholder="Escribe la tarea para el agente..."
          className="input flex-1 text-sm"
        />

        {/* Send button */}
        <button
          type="submit"
          disabled={!instruction.trim()}
          className="btn-primary text-xs flex-shrink-0 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Send className="w-3.5 h-3.5" />
          Enviar
        </button>

        {/* Agent Sync button */}
        {onSync && (
          <button
            type="button"
            onClick={() => onSync(projectId)}
            className="btn-ghost text-xs flex-shrink-0"
            title="Agent Sync: consolida contexto de todos los agentes del proyecto"
          >
            <Users className="w-3.5 h-3.5" />
            Sync
          </button>
        )}
      </form>
    </div>
  );
}
